module.exports = __webpack_public_path__ + "static/img/Horsham.7767c546.jpg";